import { RateAdjustment__RateNoticeEmailKind } from '@admin/schema';

const RATE_NOTICE_EMAIL_LABEL: Record<RateAdjustment__RateNoticeEmailKind, string> = {
  [RateAdjustment__RateNoticeEmailKind.None]: 'Excluded',
  [RateAdjustment__RateNoticeEmailKind.Standard]: 'Standard',
  [RateAdjustment__RateNoticeEmailKind.ProtectionPlanIncentive]: 'Protection plan incentive',
};

export function formatRateNoticeEmailKind(kind: RateAdjustment__RateNoticeEmailKind): string {
  return RATE_NOTICE_EMAIL_LABEL[kind];
}
